<template>
    <section class="pda-default">
        <div class="mdc-card mdc-elevation--z3 pdb-16" v-if="certificatesData.length">
            <div class="t-subtitle2 mgt-16 mgl-16 mgr-16">
                {{$t('695')}}
                <!-- 증명서 -->
            </div>
            <div v-if="certificatesData.length">

                <div v-for="(certificate, index) in certificatesData" :key="index">
                    <div class="d-flex flex-row align-content-center pdt-16 mgl-8 mgr-8">
                        <div class="pdl-8 pdr-8">
                            <img :src="certificate.image" v-if="certificate.image" class="certificate">
                        </div>
                        <div class="pdl-8 pdr-8 flex-grow-1 align-self-center">
                            {{certificate.name}}
                        </div>
                    </div>
                </div>
                
            </div>
            <div class="pdt-16 mgl-16 mgr-16" v-else >
                {{$t('696')}}
                <!-- 본 강의와 연관된 증명서가 없습니다. -->
            </div>
        </div>
    </section>
</template>


<script>
/**
 * 차수 상세 인증서 탭 컴포넌트(degree view certification tab component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import degreeApi from '@/api/degreeApi.js'
export default {
    data() {
        return {
            certificatesData: [],
        }
    },

    mounted() {
        this.fetchData()
    },

    methods: {
        // 인증서 API 호출 및 데이터 설정(call api data)
        fetchData() {
            let responseData = null
            let params = this.setParams()

            degreeApi.guestLearnOnlineViewCertificates(params).then((response) => {
                this.certificatesData = response.data.data
            }).catch((err) => {})
        },
        // 파라미터 설정(set parameter)
        setParams() {
            const params = {
                degreeId: this.$route.params.degreeId
            }
            return params
        },
    }

}
</script>